import React from "react";
import './styles/landing.css';
import hero_img from './styles/images/Hero-img.jpg';
import about_img1 from './styles/images/about-img.jpg';
import about_img2 from './styles/images/about-img2.jpg';
import about_img3 from './styles/images/about-img3.jpg';
import NewsTicker from "./marequee";
import TestimonialMarquee from "./testimonialmarquee";
import Card from "./card";
import Card2 from "./card copy 2";
import Card1 from "./card copy";
import Footer from "./Footer";
import wabes from './styles//images/download.svg';
import graph from './styles/images/higher-graphs.gif';
import training from'./styles/images/training.gif';
import support from './styles/images/support.gif';
import Static from './styles/images/service-icon.png';
import animated from './styles/images/output-onlinegiftools.gif';
import animated1 from './styles/images/output-onlinegiftools1.gif';
import Static1 from './styles/images/appoint-icon.png';
import client from './styles/images/Client-icon.png';
import hour from './styles/images/historical-icon.png';
import training1 from './styles/images/training-icon.png';
import  { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import AOS from "aos";
import "aos/dist/aos.css";
function Landing() {

    const [newsletter , setNewsletter] = useState("");
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // General email validation regex
        return emailRegex.test(email);
      };
      useEffect(() => {
        AOS.init({
          duration: 1000,  // Animation duration
          easing: 'ease',  // Easing function
          once: false,    // Re-run animations when scrolling back
        });
      }, []);
    const HandleEmail = (e) => {
        let email;
        e.preventDefault();
        if (!isValidEmail(newsletter)) {
            toast.error("Please enter a valid email address!");
            return;
          }
          email = newsletter;
          toast.info(`Subscribing ${newsletter} to the newsletter...`);
        setTimeout(()=>{
            toast.success('Subscribed to our newsletter!');

        },2000);
        setNewsletter(" ")

    }

  const navigate = useNavigate();
    const [counts, setCounts] = useState({
        count1: 0,
        count2: 0,
        count3: 0,
    });

    const targets = [250, 7000, 10000];
    const refs = [useRef(null), useRef(null), useRef(null)];
    const duration = 2000; // 2 seconds

    useEffect(() => {
        refs.forEach((ref, index) => {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        let start = 0;
                        const increment = Math.ceil(targets[index] / (duration / 50));

                        const interval = setInterval(() => {
                            start += increment;
                            if (start >= targets[index]) {
                                setCounts((prevCounts) => ({
                                    ...prevCounts,
                                    [`count${index + 1}`]: targets[index],
                                }));
                                clearInterval(interval);
                            } else {
                                setCounts((prevCounts) => ({
                                    ...prevCounts,
                                    [`count${index + 1}`]: start,
                                }));
                            }
                        }, 50);
                    }
                },
                { threshold: 0.5 }
            );

            if (ref.current) {
                observer.observe(ref.current);
            }

            return () => {
                if (ref.current) {
                    observer.unobserve(ref.current);
                }
            };
        });
    }, []);
        
    return (
        <>
            <section id="Hero">
                {/* Background Shape */}
                <div className="hero-background"></div>

                {/* Content */}
                <div className="container">
                    <div className="row">
                        {/* Left Column - Text */}
                        <div className="col-lg-5 col-md-6 col-sm-12" id="hero-col1">
                            <h1 className="hero-title" data-aos="fade-up">
                                Care <br /> That Feels Like
                                <span className="hero-highlight" data-aos="fade-up" aos-delay="2000"> Family</span>
                            </h1>
                            <h4 className="hero-subtitle" data-aos="fade-up">
                                Dedicated to Your Care, Every Step of the Way
                            </h4>
                          
                            
                        </div>
                        {/* Right Column */}
                        <div className="col-lg-6 col-md-6 col-sm-12 mb-3" id="hero-col2" data-aos="fade-up">
                            <img src={hero_img} alt="Caring home healthcare services in Minnesota - Sammah Home Care" id="hero-img" />

                        </div>
                    </div>
                    <div className="row mb-4">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                        <button className="hero-btn" onClick={()=> navigate('/service')} data-aos="fade-up">
                            <img src={Static} alt="Static Site" id="static"/>
                            <img src={animated} alt="Animated Site" id="animated"/>
                                Our Services
                            </button>
                            <br />
                            <button className="hero-btn" onClick={()=> window.location.href=`https://calendly.com/samahhomeh/30min?month=2025-03`} data-aos="fade-up">
                                <img src={Static1} alt="Static Site" id="static"/>
                                <img src={animated1} alt="Animated Site" id="animated1"/>
                            Schedule a Consultation
                            </button>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">

                        </div>
                    </div>
                </div>
                
            </section>
            <section id="hero-about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12" id="about-column">
                            <h1 data-aos="fade-up">Quality Home Care You Can Trust</h1>
                            <p>
                                Do you have senior loved ones who need professional care? Help them achieve the quality of life they deserve by allowing us to take care of them. With our highly skilled caregivers, you can rest easy knowing that your loved ones are well-taken care of. Our services are all intended to address their unique health and personal needs. We look forward to serving you and your loved ones soon!
                            </p>
                           
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12" id="about-column1">
                           
                            <div className="img-hold" data-aos="fade-up">
                                <img src={about_img1} alt="Professional home care services in Minnesota – Sammah Home Care" id="about-img" />
                            </div>
                            
                        </div>
                    </div>
                    <div className="row mt-5">
                        <div className="col-lg-5 col-md-6 col-sm-12" id="about-column1">
                        
                            <div className="img-hold">
                                <img src={about_img2} alt="Professional home care services in Minnesota – Sammah Home Care" id="about-img" />
                            </div>
                           
                        </div>
                        {/* <div className="col-lg-6 col-md-6 col-sm-12" id="about-column">
                            <h1>Exceptional Home Care for Your Loved Ones</h1>
                            <p>
                            Caring for an aging loved one can be challenging, but you don’t have to do it alone. Our compassionate caregivers are dedicated to providing personalized support, ensuring comfort, safety, and dignity at home. With our expertise, your loved ones receive the highest quality of care tailored to their unique needs. Let us help them enjoy a better quality of life while giving you peace of mind. We’re honored to be part of their journey to well-being.                            </p>
                            <button className="hero-btn">
                                Learn More
                            </button>
                        </div> */}
                        <div className="col-lg-6 col-md-6 col-sm-12" id="about-column">
                            <h1 data-aos="fade-up"><span className="highlight">Samah Home Care </span>Minnesota</h1>
                            <p>
                                Whether you require compassionate in-home assistance or you're a dedicated family caregiver seeking support, <strong>Samah Home Care</strong> is here to provide the right solution for you. Unlike other home care providers in Minnesota, we focus on both clients and caregivers, creating a smooth and supportive experience for all. From expert guidance on home care services to professional administrative support, we are committed to delivering care with integrity, respect, and personalized attention. Whether you're beginning home care services for the first time or considering a transition to a new provider, <strong>Samah Home Care</strong> is ready to meet all your non-medical home care needs with excellence and compassion.
                            </p>
                            <strong data-aos="fade-up"    >
                                If you're starting home care services for the first time or looking to switch to a new PCA agency, discover how Samah Home Care can assist you in fulfilling your non-medical home care requirements.
                            </strong>
                            <br /><br />
                            <button className="nav0cta1" onClick={()=> navigate('/why-samah-homes')}    data-aos="fade-up">
                                About Samah Home Care
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <br /><br />
            <NewsTicker data-aos="fade-up"  />
            {/* <TestimonialMarquee /> */}
            <section id="hero-about1" >
                <img src={wabes} alt="Waves" id="waves" />
                <div className="container">
                    <div className="row mt-5 text-center">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h1 className="mt-5" data-aos="fade-up">Begin Your Experience</h1>
                        </div>
                    </div>
                    <div className="row p-5">
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                            <div className="card1" ref={refs[0]} data-aos="fade-up">
                                <img src={client} alt="" width={"50px"} height={"50px"} />
                                {/* <h2>{counts.count1}+</h2> */}
                                <p>Proudly delivering exceptional home health care services across Minnesota</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                            <div className="card1" ref={refs[1]} data-aos="fade-up">
                                <img src={hour} alt="" width={"50px"} height={"50px"} />
                                <h2>{counts.count2}+</h2>
                                <p>Training Sessions Conducted</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                            <div className="card1" ref={refs[2]} data-aos="fade-up">
                                <img src={training1} alt="" width={"50px"} height={"50px"} />
                                <h2>{counts.count3}+</h2>
                                <p>Hours of Deserving Care</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="hero-newsletter">
            <div className="wrap"></div>
                <div className="row">
                    <div className="col-lg-7 col-md-6 col-sm-12" id="newsletter-col1">
                        <h2>
                           Samah home care Newsletter :
                        </h2>
                        <p>
                            Sign up to receive our latest news and updates on our services. We will keep you informed about our latest news, tips, and advice on caring for your loved ones. We will also share our latest promotions and special offers. Don’t miss out on the opportunity to stay connected with us. Sign up now!
                        </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12" id="newsletter-col2">
                        <input type="email" className="form-control" value={newsletter} placeholder="Enter your email address" id="newsletter-input" onChange={(e) => setNewsletter(e.target.value)} /><br />
                        <button className="btn btn-primary" id="newsletter-btn" onClick={HandleEmail} >Submit</button>
                    </div>
                </div>
            </section>
            <section id="hero-about" className="mb-4">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12" id="about-column">
                            <h1 data-aos="fade-up">Compassionate Care for Your Loved Ones</h1>
                            <p data-aos="fade-up">
                                Caring for your senior loved ones is our top priority. We provide professional, reliable, and personalized home care to ensure they live comfortably and with dignity. Our skilled caregivers are dedicated to meeting their unique health and personal needs, giving you peace of mind. Let us be a trusted part of your family’s journey to a better quality of life. We’re here for you every step of the way!                            </p>
                            {/* <button className="hero-btn">
                                Learn More
                            </button> */}
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12" id="about-column1">
                           
                            <div className="img-hold" data-aos="fade-up">
                                <img src={about_img3} alt="Professional home care services in Minnesota – Sammah Home Care" id="about-img" />
                            </div>
                         
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    )
};

export default Landing;